import { UnifiedFieldIcon } from '@modules/common/components/UnifiedFieldIcon';
import { UNIFIED_FIELD_HELP_CENTER_DOC } from '@modules/common/constants';
import { Box, Button, Link, Paper, Stack, Typography } from '@mui/material';

export const CreateNewUnifiedFieldDrawerHeader = () => {
  return (
    <Paper>
      <Stack
        direction="row"
        px={3}
        py={2}
        justifyContent="space-between"
        alignItems="center"
      >
        <Typography variant="h6" color="text.secondary">
          <Box sx={{ pr: 1 }} component="span">
            <UnifiedFieldIcon fill="currentColor" />
          </Box>
          Create Unified Field
        </Typography>
        <Button
          variant="text"
          color="primary"
          LinkComponent={Link}
          href={UNIFIED_FIELD_HELP_CENTER_DOC}
          target="_blank"
        >
          What is a Unified field?
        </Button>
      </Stack>
    </Paper>
  );
};
